/**
 * Check if a given value is it a number
 *
 * @param {any} value - The value to check
 * @returns {boolean} True if the given value is a boolean, false otherwise
 */
export const isNumber = (value: unknown): value is number => {
  if (Array.isArray(value)) return false;
  return (typeof value === 'number' && !isNaN(value)) || ((!!value || value === 0) && +value === Number(value));
};
